export default function truncateWithEllipses(text: string, max: number = 20) {
  return text && text.length > max ? text.substring(0, max) + '...' : text;
}
